import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner, Table } from 'react-bootstrap';
import RequestServies from "../../../services/RequestServies";
import Swal from "sweetalert2";

const ItemViewModal = ({ show, handleClose, item }) => {
  console.log("POOOO", item)
  const [itemData, setItemData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchItemData = async () => {
    try {
      setLoading(true);
      const response = await RequestServies.getItemsByRequisitionNo(item?._id);
      if (response?.status === "success") {
        console.log("data", response?.data)
        setItemData(response?.data);
      }
    } catch (err) {
      // Swal.fire(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && item) {
      fetchItemData();
    }
  }, [show, item]);

  const handlePrint = () => {
    const formatDate = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }).replace(",", "");
    };

    const printWindow = window.open('', '_blank');

    const htmlMRvContent = `
    <html lang="en">
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport"/>
      <title>Material Receipt Voucher</title>
    </head>
    <body style="background-color: #f7fafc; padding: 16px;">
      <div style="max-width: 1024px; margin: 0 auto; background-color: white; padding: 24px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
          <div>
            <h1 style="font-size: 1.25rem; font-weight: bold;">Indigo Infraprojects Pvt. Ltd.</h1>
            <p style="font-size: 0.875rem;">3rd Floor, Plot No. - 12/B, Pocket 3, Sector - 17, Dwarka</p>
            <p style="font-size: 0.875rem;">New Delhi - 110 075, Ph : +91-11-4572 0141 / 4445 8664</p>
          </div>
          <p style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 1.1rem; font-weight: bold; color:black;">
            DIGITAL COPY
          </p>
          <div style="text-align: right;">
            <img src="https://indigoinfra.in/img/product/product-1739471679615.jpeg" alt="Indigo Infraprojects Pvt. Ltd. logo" style="margin-bottom: 8px; width: 100px; height: 50px;"/>
            <h2 style="font-size: 1.125rem; font-weight: bold;">MATERIAL REQUEST VOUCHER</h2>
          </div>
        </div>

        <div style="display: flex; justify-content: space-between; margin-bottom: 16px;">
          <div>
            <p>Requistion No. : <span style="font-weight: bold;">${item?.requisitionNo || ''}</span></p>
            <p>Requisition Status: <strong>${item?.status === 'PO Pending'
        ? 'Pending with PO Team'
        : item?.status === 'open'
          ? 'Add Item(StoreKeeper)'
          : item?.status === 'submit'
            ? 'Project Manager Approval Pending'
            : 'Pending with Central Team(Manoj Ji & Team)'
      }</strong></p>
          </div>
          <div>
            <p>Project Code : ${item?.store?.storeCode}</p>
            <p>Project Name : ${item?.store?.name?.toUpperCase() || ''} </p>
            <p>Location : <strong>${item?.store?.location?.toUpperCase() || ''}</strong></p>
            <p>Date :<strong>${item?.createdAt ? formatDate(item.createdAt) : ''}</strong></p>
          </div>
        </div>

        <table style="width: 100%; border-collapse: collapse; border: 1px solid #cbd5e0; margin-bottom: 16px;">
          <thead>
            <tr>
              <th style="border: 1px solid #cbd5e0; padding: 8px;">S.No</th>
              <th style="border: 1px solid #cbd5e0; padding: 8px;">Description</th>
              <th style="border: 1px solid #cbd5e0; padding: 8px;">Unit</th>
              <th style="border: 1px solid #cbd5e0; padding: 8px;">Required Qty.</th>
              <th style="border: 1px solid #cbd5e0; padding: 8px;">Recived Qty</th>
              <th style="border: 1px solid #cbd5e0; padding: 8px;">Remark</th>
            </tr>
          </thead>
          <tbody>
            ${itemData.map((itm, index) => `
                <tr>
                  <td style="border: 1px solid #cbd5e0; padding: 8px; height: 32px;">${index + 1}</td>
                  <td style="border: 1px solid #cbd5e0; padding: 8px;">${itm?.inventory?.masterItem?.description || ''}</td>
                  <td style="border: 1px solid #cbd5e0; padding: 8px;">${itm?.inventory?.masterItem?.unit?.name || ''}</td>
                  <td style="border: 1px solid #cbd5e0; padding: 8px;">${itm?.qtyRequired ?? ''}</td>
                  <td style="border: 1px solid #cbd5e0; padding: 8px;">${itm?.qtyRecived ?? ''}</td>
                  <td style="border: 1px solid #cbd5e0; padding: 8px;">${itm?.status || ''}</td>
                </tr>
              `).join('')
      }
          </tbody>
        </table>

        <div style="display: flex; justify-content: space-between;">
          <div><p>Signature &amp; Name</p></div>
          <div><p>Prepared By: <strong>${item?.user?.name || ''}</strong></p></div>
          <div><p>Date:<strong>${item?.createdAt ? formatDate(item.createdAt) : ''}</strong></p></div>
          <div><p>Signature &amp; Name</p></div>
          <div><p>Approved By</p></div>
          <div><p>Date</p></div>
        </div>
      </div>
    </body>
    </html>
  `;

    printWindow.document.write(htmlMRvContent);
    printWindow.document.close();
    printWindow.print();
  };


  return (
    <Modal className="fade" show={show} onHide={handleClose} size="lg">
      <Modal.Header>
        <Modal.Title><i className="fas fa-eye"></i> Item Details</Modal.Title>
        <Button variant="" className="btn-close" onClick={handleClose}></Button>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
            <div className="mt-2">Loading item data...</div>
          </div>
        ) : itemData.length === 0 ? (
          <div className="text-center py-4">No item data found.</div>
        ) : (
          <Table striped bordered hover responsive size="sm">
            <thead>
              <tr>
                <th>#</th>
                <th>Part No</th>
                <th>Description</th>
                <th>Qty Required</th>
                <th>Status</th>
                <th>PO Status</th>
                <th>PO NO.</th>

              </tr>
            </thead>
            <tbody>
              {itemData.map((itm, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{itm?.inventory?.masterItem?.partNo || 'N/A'}</td>
                  <td>{itm?.inventory?.masterItem?.description || 'N/A'}</td>
                  <td>{itm?.qtyRequired ?? 'N/A'}</td>
                  <td>{itm?.status ?? 'N/A'}</td>
                  <td>{itm?.poStatus ?? 'N/A'}</td>
                  <td>
                    {['rejected', 'autoclosed', 'forceclosed', 'tranfer request', 'local'].includes(itm?.status)
                      ? 'N/A'
                      : itm?.poStatus === 'generated' && (!itm?.po?.poNumber || itm?.po?.poNumber === '')
                        ? 'Local'
                        : itm?.po?.poNumber ?? 'NA'}
                  </td>


                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>

      <Modal.Footer>
        {/*
        <Button variant="success" onClick={handlePrint}>
          Print
        </Button>
*/}
        <Button variant="danger" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(ItemViewModal);
